module.exports = __webpack_public_path__ + "static/media/ios_notifications.70eba576.png";